import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import * as S from './styles';

import { COLORS } from '../../../utils/theme/colors';

interface MeterDeviceProps {
  meterDevice: any;
  loadingGetMeterDevice?: boolean;
  style?: any;
}

const antLoadingIcon = (
  <LoadingOutlined style={{ fontSize: 16, marginRight: 10 }} spin />
);

export const MeterDevice = ({
  meterDevice,
  loadingGetMeterDevice,
  style,
}: MeterDeviceProps) => {
  if (!meterDevice) {
    return null;
  }

  if (loadingGetMeterDevice) {
    return (
      <S.MeterDeviceResponseContainer
        style={{ justifyContent: 'center' }}
        color='#f3f4f6'
        borderColor='#f3f4f6'
        isLoading
      >
        <Spin indicator={antLoadingIcon} />

        <S.Label>{'Testando conexão'}</S.Label>
      </S.MeterDeviceResponseContainer>
    );
  }

  if (meterDevice.status !== 1) {
    return (
      <S.MeterDeviceResponseContainer
        style={{ justifyContent: 'center', ...style }}
        color={'#fbf5d6'}
        borderColor={'#ffda29'}
      >
        <S.StyledDot color={'#ffda29'} />
        <S.MeterDeviceLabel color={' #7f7f7f'} style={{ marginBottom: 0 }}>
          O medidor está offline
        </S.MeterDeviceLabel>
      </S.MeterDeviceResponseContainer>
    );
  }

  return (
    <S.MeterDeviceResponseContainer
      color={'#f0fdf4'}
      style={style}
      borderColor={COLORS.autonomy}
    >
      <S.TitleContainer style={{ justifyContent: 'center' }}>
        <S.StyledDot color={COLORS.autonomy} />

        <S.MeterDeviceLabel color='#9da9ab' style={{ marginRight: 2 }}>
          Medidor conectado
        </S.MeterDeviceLabel>
      </S.TitleContainer>
      <S.Label color='#9da9ab' style={{ marginRight: 2, marginLeft: 8 }}>
        Fase A:
      </S.Label>
      <S.Label style={{ fontWeight: 'normal', color: '#000' }}>
        {typeof meterDevice?.current?.phase?.['01'] === 'number'
          ? `${meterDevice.current.phase['01'].toFixed(2)}A`
          : '  '}
      </S.Label>
      <S.Label color='#9da9ab' style={{ marginRight: 2, marginLeft: 8 }}>
        Fase B:
      </S.Label>
      <S.Label style={{ fontWeight: 'normal', color: '#000' }}>
        {typeof meterDevice?.current?.phase?.['02'] === 'number'
          ? `${meterDevice.current.phase['02'].toFixed(2)}A`
          : '  '}
      </S.Label>
      <S.Label color='#9da9ab' style={{ marginRight: 2, marginLeft: 8 }}>
        Fase C:
      </S.Label>
      <S.Label style={{ fontWeight: 'normal', color: '#000' }}>
        {typeof meterDevice?.current?.phase?.['03'] === 'number'
          ? `${meterDevice.current.phase['03'].toFixed(2)}A`
          : '  '}
      </S.Label>
    </S.MeterDeviceResponseContainer>
  );
};
